import { QueryCache, QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ApiError } from './api';

/**
 * Query defaults, tuned for a low-traffic internal tool.
 *
 * A 30-second stale window avoids refetch storms without risking a stale balance on
 * screen. Mutations do not retry: a failed write in a billing system should surface
 * immediately rather than be attempted several times silently.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
    queryCache: new QueryCache({
      onError: (error) => {
        // Mutation errors are handled at the call site so a form can map them onto fields.
        // Query errors have no such owner, so they surface here.
        if (error instanceof ApiError) {
          // 401 is already handled by the refresh interceptor; surfacing it would show a
          // spurious error during an otherwise invisible token renewal.
          if (error.status === 401) return;
          toast.error(error.message);
          return;
        }
        toast.error('Could not load data. Please try again.');
      },
    }),
  });
}
